import createHistory from 'history/createBrowserHistory';
import { routerMiddleware, routerReducer } from 'react-router-redux';
import analyticsReducer from 'reducers/analytics';
import authReducer from 'reducers/authentication';
import bookingReducer from 'reducers/booking';
import clientReducer from 'reducers/client';
import errorReducer from 'reducers/error';
import financialReducer from 'reducers/financial';
import iqosReducer from 'reducers/iqos';
import labelReducer from 'reducers/labels';
import menuReducer from 'reducers/menus';
import venueReducer from 'reducers/venue';
import { applyMiddleware, compose, createStore } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { persistCombineReducers, persistStore } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';
import thunkMiddleware from 'redux-thunk';

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2,
};

const routerHistory = createHistory();
const routeMiddleware = routerMiddleware(routerHistory);

const reducers = persistCombineReducers(persistConfig, {
  analytics: analyticsReducer,
  iqos: iqosReducer,
  menu: menuReducer,
  authentication: authReducer,
  client: clientReducer,
  venue: venueReducer,
  booking: bookingReducer,
  form: formReducer,
  error: errorReducer,
  router: routerReducer,
  financial: financialReducer,
  labels: labelReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
  reducers,
  composeEnhancers(
    applyMiddleware(thunkMiddleware /*, loggerMiddleware*/, routeMiddleware)
  )
);
export const persistor = persistStore(store);

window.persistor = persistor;



// WEBPACK FOOTER //
// ./src/store/index.jsx